import React from 'react';
import {
  Edit,
  SimpleForm,
  TopToolbar,
  ShowButton,
  DeleteButton,
} from 'react-admin';
import { LeadForm } from './LeadForm';

const EditActions = () => (
  <TopToolbar>
    <ShowButton />
    <DeleteButton />
  </TopToolbar>
);

export const LeadEdit = () => (
  <Edit actions={<EditActions />}>
    <SimpleForm>
      <LeadForm isEdit={true} />
    </SimpleForm>
  </Edit>
);